"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultVerdiForOpsjon: function() {
        return defaultVerdiForOpsjon;
    },
    defaultVerdiForDatoegenskap: function() {
        return defaultVerdiForDatoegenskap;
    },
    gyldigeOpsjonerForFelt: function() {
        return gyldigeOpsjonerForFelt;
    }
});
var _has = /*#__PURE__*/ _interop_require_default(require("lodash/has"));
var _sjekker = require("./sjekker");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var defaultVerdiForOpsjon = function(felt, data) {
    if ((0, _has.default)(felt, "opsjon.defaultVerdi")) {
        return (0, _sjekker.finnDefaultVerdi)(felt.opsjon.defaultVerdi, data);
    }
    return Array.isArray(felt.opsjon.verdier) ? felt.opsjon.verdier[0] : undefined;
};
var defaultVerdiForDatoegenskap = function(felt, dialogdata) {
    var _ref = felt.datovelger || {}, startdato = _ref.startdato, sluttdato = _ref.sluttdato;
    return {
        startdato: startdato ? (0, _sjekker.finnDefaultVerdi)(startdato, dialogdata) : startdato,
        sluttdato: sluttdato ? (0, _sjekker.finnDefaultVerdi)(sluttdato, dialogdata) : sluttdato
    };
};
var gyldigeOpsjonerForFelt = function(kodelisteConfig, felt, dialogData, visningsdata, kodelister) {
    var _kodelisteConfig, _felt_opsjon, _gyldigeOpsjonerDefinisjon, _gyldigeOpsjonerDefinisjon1;
    var gyldigeOpsjonerDefinisjon = (_kodelisteConfig = kodelisteConfig) === null || _kodelisteConfig === void 0 ? void 0 : _kodelisteConfig.find(// eslint-disable-next-line no-shadow
    function(kodelisteConfig) {
        var _felt_transformer;
        return kodelisteConfig.kodeliste === ((_felt_transformer = felt.transformer) === null || _felt_transformer === void 0 ? void 0 : _felt_transformer.kodeliste);
    });
    var opsjonsListe = function(opsjoner) {
        return [
            defaultVerdiForOpsjon(felt, dialogData)
        ].concat(opsjoner);
    };
    var getGyldigeOpsjoner = function() {
        return opsjonsListe(gyldigeOpsjonerDefinisjon.gyldigeOpsjoner);
    };
    var getGyldigeOpsjonerGittAnnenVerdi = function() {
        var gyldigeOpsjonerGitt = gyldigeOpsjonerDefinisjon.gyldigeOpsjonerGitt;
        return opsjonsListe(gyldigeOpsjonerGitt.opsjonerGittVerdi[dialogData[gyldigeOpsjonerGitt.referanse]]);
    };
    var opsjonsverdier = (_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.verdier;
    var gruppertVerdiHvisFeltErGruppert = function(verdi) {
        var _felt_opsjon;
        return ((_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.gruppering) ? {
            tekniskNavn: verdi,
            presentasjonsrekkefoelge: "ingen"
        } : verdi;
    };
    var viderefoertEksisterendeVerdi = function() {
        var _felt_opsjon;
        return ((_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.viderefoerEksisterendeVerdi) && dialogData[felt.referanse] ? [
            gruppertVerdiHvisFeltErGruppert(dialogData[felt.referanse])
        ] : [];
    };
    var getOpsjonsverdier = function() {
        var _felt_opsjon, _verdierGittBetingelse_find;
        var verdierGittBetingelse = ((_felt_opsjon = felt.opsjon) === null || _felt_opsjon === void 0 ? void 0 : _felt_opsjon.verdierGittBetingelse) || [];
        var viderefoertVerdi = viderefoertEksisterendeVerdi();
        /* Bruker opsjonsverdier hvis ikke verdierGittBetingelse er definert, eller som defaultverdi hvis
     * ingen betingelser er oppfylt */ var opsjonsverdierGittBetingelse = ((_verdierGittBetingelse_find = verdierGittBetingelse.find(function(betingelse) {
            return (0, _sjekker.foelgerBetingelse)(dialogData, betingelse.betingelse, visningsdata, [], kodelister);
        })) === null || _verdierGittBetingelse_find === void 0 ? void 0 : _verdierGittBetingelse_find.verdier) || opsjonsverdier;
        return viderefoertVerdi[0] && !opsjonsverdierGittBetingelse.map(function(b) {
            return b.tekniskNavn || b;
        }).includes(viderefoertVerdi[0].tekniskNavn || viderefoertVerdi[0]) ? viderefoertVerdi.concat(opsjonsverdierGittBetingelse) : opsjonsverdierGittBetingelse;
    };
    return ((_gyldigeOpsjonerDefinisjon = gyldigeOpsjonerDefinisjon) === null || _gyldigeOpsjonerDefinisjon === void 0 ? void 0 : _gyldigeOpsjonerDefinisjon.gyldigeOpsjoner) ? getGyldigeOpsjoner() : ((_gyldigeOpsjonerDefinisjon1 = gyldigeOpsjonerDefinisjon) === null || _gyldigeOpsjonerDefinisjon1 === void 0 ? void 0 : _gyldigeOpsjonerDefinisjon1.gyldigeOpsjonerGitt) ? getGyldigeOpsjonerGittAnnenVerdi() : getOpsjonsverdier();
};
